import { UserLogin } from "@/login";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/login")({
  component: UserLogin,
});
